<template>
  <div class="w-full d-flex items-stretch mb-2">
    <span
      class="
        rounded-l
        d-flex
        border-l
        border-t
        border-b
        border-secondary-20
        bg-secondary-10
        items-center
        justify-center
        w-8
      "
    >
      {{ index + 1 }}
    </span>

    <span class="flex-grow">
      <!-- -mb-0.25, a trick to overlap border -->
      <AhaInput
        class="-mb-0.25"
        :rounded="false"
        :max-length="150"
        placeholder="Prompt"
        :highlight-on-hover="false"
        v-model="title"
        @input="handleTitleChanged"
      />
      <AhaInput
        :rounded="false"
        :max-length="150"
        placeholder="Answer"
        :highlight-on-hover="false"
        v-model="pairTitle"
        @input="handleTitleChanged"
      />
    </span>

    <span
      class="
        border-t
        border-r
        border-b
        rounded-r
        border-secondary-20
        bg-secondary-10
        text-secondary-50
        d-flex
        items-center
        justify-center
        w-8
      "
      :class="{
        'cursor-pointer': isDeletable,
        'cursor-not-allowed': !isDeletable,
      }"
      @click="isDeletable && handleDeleteSlideOption(slideOption.id)"
    >
      <i class="far fa-trash-alt" />
    </span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    slideOption: {
      type: Object,
      required: true,
    },
    handleDeleteSlideOption: {
      type: Function,
      required: true,
    },
    handleSlideOptionChanged: {
      type: Function,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      pairTitle: '',
    }
  },
  mounted() {
    this.handleSlideOptionChangedDebounce = _.debounce(this.handleSlideOptionChanged, 600)
    this.title = this.slideOption.title
    this.pairTitle = this.slideOption.pairTitle
  },
  methods: {
    handleTitleChanged() {
      const payload = {
        title: this.title,
        pairTitle: this.pairTitle,
      }

      this.handleSlideOptionChangedDebounce(this.slideOption.id, payload)
    },
  },
}
</script>
